const TONE_CLASSES = {
  error: 'bg-error-container text-on-error-container border-error/30',
  success: 'bg-primary-container text-on-primary-container border-primary/30',
  info: 'bg-surface-container-high text-on-surface border-outline-variant',
};

const ICONS = {
  error: 'error',
  success: 'check_circle',
  info: 'info',
};

export function ToastViewport({ toasts, onDismiss }) {
  if (toasts.length === 0) return null;

  return (
    <div
      className="fixed inset-x-0 bottom-4 z-[100] flex flex-col items-center gap-2 px-4 sm:left-auto sm:right-4 sm:items-end sm:px-0"
      aria-label="Notificações"
    >
      {toasts.map((toast) => (
        <div
          key={toast.id}
          role={toast.type === 'error' ? 'alert' : 'status'}
          aria-live={toast.type === 'error' ? 'assertive' : 'polite'}
          className={`w-full max-w-sm rounded-lg border p-4 shadow-lg ${TONE_CLASSES[toast.type] || TONE_CLASSES.info}`}
        >
          <div className="flex items-start gap-3">
            <span className="material-symbols-outlined text-[20px] shrink-0 mt-0.5">
              {ICONS[toast.type] || ICONS.info}
            </span>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium">{toast.message}</p>
              {toast.detail && <p className="text-xs opacity-70 mt-0.5">{toast.detail}</p>}
              {toast.requestId && (
                <p className="text-[10px] opacity-50 mt-1 font-mono truncate" title="ID de suporte">
                  ID: {toast.requestId}
                </p>
              )}
              {toast.actionLabel && (
                <button
                  onClick={() => { toast.onAction?.(); onDismiss(toast.id); }}
                  className="mt-2 text-xs font-bold underline hover:no-underline"
                >
                  {toast.actionLabel}
                </button>
              )}
            </div>
            <button
              onClick={() => onDismiss(toast.id)}
              aria-label="Fechar notificação"
              className="shrink-0 opacity-60 hover:opacity-100"
            >
              <span className="material-symbols-outlined text-[18px]">close</span>
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}
